import { useQuery } from '@tanstack/react-query';
import { type MeResponse, Routes } from '@tg-leads/contracts';

import { api } from './api';

/**
 * Single source of truth for "who am I". Used by AppLayout to render the
 * right nav (admin / sales / lead) and by RequireRole to gate routes.
 *
 * Cached aggressively (5min stale) — the user's role doesn't change without
 * a re-login, and re-login clears the JWT which forces a refetch anyway.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => api.get<MeResponse>(Routes.auth.me),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/** Admin → all roles, lead → sales|lead, sales → sales only. */
export function roleSatisfies(actual: string, required: string): boolean {
  const rank: Record<string, number> = { sales: 1, lead: 2, admin: 3 };
  return (rank[actual] ?? 0) >= (rank[required] ?? 0);
}
